<template xmlns="">
    <div class="teka-container">
        <iframe :src="tekaUrl"></iframe>
    </div>
</template>

<script>
import { mapState } from "vuex";
import cloneDeep from 'lodash/cloneDeep';
import {config} from '@/config';
import axios from "axios";

export default {
    menuName: 'TÉKA',
    name: 'teka',

  mounted() {
    this.fetchTekaToken();
  },

    computed: {
        ...mapState({
            user: state => state.user
        }),

        tekaUrl() {
            let attraction = this.getAttraction();

            let baseUrl = 'https://teka.csodasmagyarorszag.hu/embeddedpages/Content/Index';

            if(config.development) {
                baseUrl = 'https://teka-teszt.csodasmagyarorszag.hu/embeddedpages/Content/Index';
            }

            let entityType = 'http%3A%2F%2Fmtu.gov.hu%2Fapi%2Frdf%2Fapi%2Fmtu%2Fneta%23Event';

            return baseUrl
                + '?token=' + this.tekaToken
                + '&externalEntityId=' + attraction.uid
                + '&externalEntityType=' + entityType
                + '&externalEntityName=' + attraction.name
                + '&externalSystem=NETA'
                + '&externalUser=' + this.user.userName
                + '&externalRole=' + this.user.selectedRole
                + '&preferredContentType=ImageGallery';
        },
      fetchTekaToken() {
        this.loading = true;
        return new Promise((resolve) => {
          axios.get(
              '/api/v1/companies/1/me/teka-token', {
                params: {
                  selectedRole: this.$store.state.user.selectedRole
                }
              }
          ).then((response) => {
            this.tekaToken = response.data.token;

            resolve(response.data.token);
          }).catch(() => {
            this.$message.error(
                'A TÉKA token betöltése sikertelen!'
            );
          });
        });
      },
    },

  data() {
    return {
      tekaToken: null
    }
  },

    methods: {
        /**
         * @returns {object}
         */
        getAttraction() {
            return cloneDeep(this.$store.getters.getCurrentAttraction);
        }
    }
}
</script>

<style lang="scss">
.teka-container {
  padding-bottom: 30px;

  iframe {
    width: 100%;
    height: calc(100vh - 200px);
    border: 0;
  }
}
</style>
